import { Product } from './types'

export const mockProducts: Product[] = [
  {
    id: 1,
    format: 'billboard',
    location_name: 'Panou Central Chișinău',
    address: 'Chișinău, str. Ștefan cel Mare, 123',
    internal_code: 'CHI-001',
    gps_coordinates: '47.0104, 28.8638',
    start_date: '2024-02-01',
    end_date: '2024-04-30',
    net_cost: 2000,
    gross_cost: 2500,
    discount: 10,
    additional_costs: {
      tipar: 300,
      montaj: 150,
      demontaj: 100
    },
    supplier_name: 'Media Solutions SRL',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '3000x2000px',
      delivery_time: '5 zile lucrătoare',
      limitations: 'Format JPG/PNG, max 10MB'
    },
    images: [
      'https://picsum.photos/200/300?random=1',
      'https://picsum.photos/200/300?random=2'
    ],
    created_at: '2024-01-15T10:30:00Z',
    modified_at: '2024-01-15T10:30:00Z'
  },
  {
    id: 2,
    format: 'citylight',
    location_name: 'Citylight Centru',
    address: 'Chișinău, bd. Dacia, 45',
    internal_code: 'CHI-002',
    gps_coordinates: '47.0056, 28.8575',
    start_date: '2024-03-01',
    end_date: '2024-05-31',
    net_cost: 1500,
    gross_cost: 1800,
    discount: 5,
    additional_costs: {
      tipar: 200,
      montaj: 100
    },
    supplier_name: 'Outdoor Advertising MD',
    payment_terms: 'postfactum',
    technical_policies: {
      file_dimensions: '1920x1080px',
      delivery_time: '3 zile lucrătoare',
      limitations: 'Format RGB, max 5MB'
    },
    images: ['https://picsum.photos/200/300?random=3'],
    created_at: '2024-01-20T14:15:00Z'
  },
  {
    id: 3,
    format: 'prismatron',
    location_name: 'Prismatron Mall',
    address: 'Chișinău, str. Ismail, 1',
    internal_code: 'CHI-003',
    start_date: '2024-01-15',
    end_date: '2024-06-15',
    net_cost: 3000,
    gross_cost: 3500,
    additional_costs: {
      tipar: 400,
      montaj: 200,
      demontaj: 150
    },
    supplier_name: 'Digital Media Pro',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '3840x2160px',
      delivery_time: '7 zile lucrătoare',
      limitations: 'Format MP4, max 50MB, durată max 30s'
    },
    images: [
      'https://picsum.photos/200/300?random=4',
      'https://picsum.photos/200/300?random=5',
      'https://picsum.photos/200/300?random=6'
    ],
    created_at: '2024-01-10T09:00:00Z',
    modified_at: '2024-01-12T11:20:00Z'
  },
  {
    id: 4,
    format: 'perete',
    location_name: 'Perete Strada Principală',
    address: 'Bălți, str. Independenței, 78',
    internal_code: 'BLT-001',
    gps_coordinates: '47.7531, 27.9283',
    start_date: '2024-02-15',
    end_date: '2024-07-15',
    net_cost: 1200,
    gross_cost: 1500,
    discount: 15,
    additional_costs: {
      tipar: 250,
      montaj: 120
    },
    supplier_name: 'Regional Advertising',
    payment_terms: 'postfactum',
    technical_policies: {
      file_dimensions: '2400x3200px',
      delivery_time: '4 zile lucrătoare',
      limitations: 'Format JPG, max 8MB'
    },
    images: ['https://picsum.photos/200/300?random=7'],
    created_at: '2024-01-08T11:45:00Z'
  },
  {
    id: 5,
    format: 'billboard_nestandart',
    location_name: 'Billboard Nestandard Aeroport',
    address: 'Chișinău, Aeroport Internațional',
    internal_code: 'CHI-004',
    gps_coordinates: '46.9277, 28.9308',
    start_date: '2024-03-15',
    end_date: '2024-08-15',
    net_cost: 4000,
    gross_cost: 4800,
    discount: 8,
    additional_costs: {
      tipar: 500,
      montaj: 250,
      demontaj: 200
    },
    supplier_name: 'Airport Media',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '4000x3000px',
      delivery_time: '10 zile lucrătoare',
      limitations: 'Format JPG/PNG, max 15MB'
    },
    images: [
      'https://picsum.photos/200/300?random=8',
      'https://picsum.photos/200/300?random=9'
    ],
    created_at: '2024-01-25T16:20:00Z'
  },
  {
    id: 6,
    format: 'console',
    location_name: 'Console Centru Comercial',
    address: 'Chișinău, bd. Ștefan cel Mare și Sfânt, 134',
    internal_code: 'CHI-005',
    start_date: '2024-04-01',
    end_date: '2024-09-30',
    net_cost: 1800,
    gross_cost: 2200,
    additional_costs: {
      tipar: 300,
      montaj: 150
    },
    supplier_name: 'Mall Advertising',
    payment_terms: 'postfactum',
    technical_policies: {
      file_dimensions: '1920x1080px',
      delivery_time: '5 zile lucrătoare',
      limitations: 'Format RGB, max 6MB'
    },
    images: ['https://picsum.photos/200/300?random=10'],
    created_at: '2024-01-28T10:00:00Z'
  },
  {
    id: 7,
    format: 'ceasuri',
    location_name: 'Ceasuri Digital Centru',
    address: 'Chișinău, str. Columna, 56',
    internal_code: 'CHI-006',
    gps_coordinates: '47.0104, 28.8638',
    start_date: '2024-05-01',
    end_date: '2024-10-31',
    net_cost: 2500,
    gross_cost: 3000,
    discount: 12,
    additional_costs: {
      tipar: 0,
      montaj: 100
    },
    supplier_name: 'Digital Displays MD',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '1920x1080px',
      delivery_time: '3 zile lucrătoare',
      limitations: 'Format MP4, max 20MB, durată max 15s'
    },
    images: [
      'https://picsum.photos/200/300?random=11',
      'https://picsum.photos/200/300?random=12'
    ],
    created_at: '2024-02-01T12:30:00Z'
  }
]
